import { __awaiter, __generator } from '../node_modules/tslib/tslib.es6.js';
import axios from '../node_modules/axios/index.js';
import { pyramidDetails } from '../apiConsts.js';

function getPyramidDetails() {
    return __awaiter(this, void 0, void 0, function () {
        var response, result, result, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios.get(pyramidDetails, {})];
                case 1:
                    response = _a.sent();
                    if (response.status === 200) {
                        result = {
                            data: response.data,
                            success: response.status == 200,
                            status: response.status,
                        };
                        return [2, result];
                    }
                    else {
                        result = {
                            data: null,
                            success: response.status == 200,
                            status: response.status,
                        };
                        return [2, result];
                    }
                case 2:
                    _a.sent();
                    result = {
                        status: 500,
                        data: null,
                        success: false,
                    };
                    return [2, result];
                case 3: return [2];
            }
        });
    });
}

export { getPyramidDetails };
//# sourceMappingURL=getPyramidDetails.js.map
